export const INITIAL_SCRAPING_BEHAVIOR = {
  nameLink: {
    title: {
      update: false,
      value: null,
    },
  },
  redirects: {
    desktop: {
      update: false,
      type: null,
      value: null,
    },
  },
  linkData: {
    update: false,
    items: [],
  },
  socialMediaTags: {
    title: {
      update: false,
      value: null,
    },
    description: {
      update: false,
      value: null,
    },
    imageUrl: {
      update: false,
      value: null,
    },
  },
};
